/**
 *base
 **/
;(function ($, window) {
  if (window._benSetupCore) return
  window._benSetupCore = true
  var _ben = {
    extend: function () {
      $.extend.apply(this, arguments)
    },
    setCookie: function (name, value, expires, domain) {
      var cookieString = name + '=' + escape(value)
      //判断是否设置过期时间
      if (expires) {
        var date = new Date()
        date.setTime(date.getTime() + expires)
        cookieString += '; expires=' + date.toGMTString()
      }
      if (domain) {
        cookieString += '; domain=' + domain
      }
      document.cookie = cookieString
    },
    /**
     * 取得指定名称的cookie值
     *
     * @method getCookie
     * @param {String} name cookie名
     * @return {String,null}  cookie值,如果name不存在,则返回null
     * @static
     */
    getCookie: function (name) {
      var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      arr = document.cookie.match(reg)
      if (arr) {
        return unescape(arr[2])
      }
      return null
    },
  }

  var initializing = false,
    fnTest = /xyz/.test(function () {
      xyz
    })
      ? /\bbase\b/
      : /.*/
  // The base Class implementation (does nothing)
  var Class = function () {}

  // Create a new Class that inherits from this class
  Class.extend = function (ns, prop) {
    if (arguments.length == 2) {
      var firstLetter = ns.split('')[0]
      if (firstLetter.toUpperCase() != firstLetter) {
        throw new Error('Class must begin with Uppercase letters:' + ns)
      }
      _ben[ns] = this.extend(prop)
      return
    }
    var base = this.prototype,
      prop = arguments[0]
    initializing = true
    var prototype = new this()
    initializing = false
    for (var name in prop) {
      // Check if we're overwriting an existing function
      prototype[name] =
        typeof prop[name] == 'function' &&
        typeof base[name] == 'function' &&
        fnTest.test(prop[name])
          ? (function (name, fn) {
              return function () {
                var tmp = this.base

                // Add a new .base() method that is the same method
                // but on the super-class
                this.base = base[name]

                // The method only need to be bound temporarily, so we
                // remove it when we're done executing
                var ret = fn.apply(this, arguments)
                this.base = tmp

                return ret
              }
            })(name, prop[name])
          : prop[name]
    }

    function _Class() {
      // All construction is actually done in the init method
      if (!initializing && this.init) this.init.apply(this, arguments)
    }

    _Class.prototype = prototype

    _Class.prototype.constructor = _Class

    _Class.extend = arguments.callee

    return _Class
  }
  _ben.Class = Class
  _ben.getTimeStamp = function (interval) {
    return Math.floor(new Date() / interval)
  }
  window.ue = _ben
})(jQuery, window)
